/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WelcomeMessageScope {
    NEW_FANS = 'NEW_FANS',
    RETURNING_FANS = 'RETURNING_FANS',
}
